
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#339299","stroke-width":"1.429","stroke-linecap":"round","stroke-linejoin":"round","clip-path":"url(#clip0_1168_59705)"}},[_c('path',{attrs:{"d":"M2.144 8.42h15.713v10a1.428 1.428 0 01-1.428 1.428H3.572a1.429 1.429 0 01-1.428-1.428v-10 0zM19.286 6.99V4.135c0-.79-.64-1.429-1.428-1.429H2.144c-.79 0-1.429.64-1.429 1.429V6.99c0 .789.64 1.428 1.429 1.428h15.714c.789 0 1.428-.64 1.428-1.428zM7.857 12.705h4.286"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1168_59705"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h19.999v19.999H0z"}})])])])
          )
        }
      }
    